"use strict";

// Detect mobile
if (typeof isMobile === "undefined") {
  let isMobile = false;
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
    isMobile = true;
    document.documentElement.classList.add('is-mobile');
  }
} // Get language


const language = document.documentElement.getAttribute('lang').match(/^([a-z]{2})/)[1]; // Load blocks

(function ($) {
  const initializeBlock = function ($block) {
    // Fix block object (for preview).
    if (!$block.hasClass('plmb')) {
      $block = $block.find('.plmb');
    } // Init block


    if (!$block.hasClass('plmb-init')) {
      $block.addClass('plmb-init');
      const $form = $block.find('form');

      if ($form.length) {
        const $submitBtn = $form.find('button[type=submit]');
        const $errorLine = $form.find('.error-line');
        const $uploadLines = $form.find('.input-line.upload');
        const $uploadInputs = $form.find('.input-line.upload > input[type=file]'); // Parsley

        if (language === 'fr') {
          Parsley.setLocale('fr');
        }

        $form.parsley({
          errorsContainer: function (Field) {
            return Field.$element.parents('.input-line');
          }
        }); // Datepicker

        const $dateInput = $form.find('.input-line.date input[type=text]');

        if ($dateInput.length) {
          if (language === 'fr') {
            $dateInput.datepicker({
              changeMonth: true,
              changeYear: true
            }, $.datepicker.regional['fr']);
          } else {
            $dateInput.datepicker({
              changeMonth: true,
              changeYear: true
            });
          }
        } // Upload file


        $uploadInputs.fileupload({
          dataType: 'json',
          url: ajax.url,
          formData: {
            action: 'form-file-upload',
            security: ajax.nonce
          },
          add: function (e, data) {
            // Deactivate submit
            $submitBtn.prop('disabled', true); // Get current input line

            const $currentInput = $(e.target).parents('.input-line'); // Get current upload label

            const $currentLabel = $currentInput.find('label'); // Change upload button text

            $currentLabel.data('oldText', $currentLabel.html()).text($currentLabel.data('send'));
            data.submit();
          },
          done: function (e, data) {
            // Get current input line
            const $currentInput = $(e.target).parents('.input-line'); // Get current elements

            const $currentLabel = $currentInput.find('label');
            const $currentHidden = $currentInput.find('.upload-hidden');
            const $currentName = $currentInput.find('.upload-name');

            if (data.result.error) {
              // Set error
              const $error = $('<div class="alert alert-warning" role="alert">' + data.result.error + '</div>');
              $errorLine.empty().append($error);
              gsap.from($error, {
                duration: 0.3,
                autoAlpha: 0,
                y: 20
              }); // Enable submit

              $submitBtn.prop('disabled', false); // Reset upload label text

              $currentLabel.html($currentLabel.data('oldText'));
            } else if (data.result.image) {
              // Update hidden field
              $currentHidden.val(data.result.image.id); // Update file name

              if ($currentName.length) {
                $currentName.remove();
              }

              const $name = $('<div class="upload-name">' + data.result.image.name.substring(data.result.image.name.length - 20, data.result.image.name.length) + ' <span>Remove</span></div>');
              $name.insertAfter($currentLabel); // Enable submit

              $submitBtn.prop('disabled', false); // Reset upload button text

              $currentLabel.html($currentLabel.data('oldText'));
            }
          }
        }); // File remove button

        $uploadLines.on('click', '.upload-name > span', function () {
          const $inputLine = $(this).parents('.input-line'); // Empty hidden field

          $inputLine.find('.upload-hidden').val(''); // Remove name

          $inputLine.find('.upload-name').remove();
        }); // Send form

        $form.submit(function (e) {
          // Prevent default submit
          e.preventDefault(); // Deactivate buttons

          $submitBtn.prop('disabled', true); // Change submit button text

          $submitBtn.data('oldText', $submitBtn.text()).text($submitBtn.data('send')); // Send form in ajax

          $.ajax({
            method: 'POST',
            url: ajax.url,
            dataType: 'json',
            data: {
              form: $form.serialize(),
              action: 'plmt-contact-form',
              security: ajax.nonce
            },
            success: function (data) {
              // Set message
              let $error;

              if (data.success) {
                $error = $('<div class="alert alert-success">' + data.success + '</div>'); // Reset form

                $form.trigger('reset');
                $form.find('.input-line.upload .upload-hidden').val('');
                $form.find('.input-line.upload .upload-name').remove();
              } else if (data.error) {
                $error = $('<div class="alert alert-warning" role="alert">' + data.error + '</div>');
              }

              $errorLine.empty().append($error);
              gsap.from($error, {
                duration: 0.3,
                autoAlpha: 0,
                y: 20
              }); // Enable submit

              $submitBtn.prop('disabled', false); // Reset submit button text

              $submitBtn.text($submitBtn.data('oldText'));
            }
          });
        });
      }
    }
  }; // Initialize each block on page load (front end).


  $(document).ready(function () {
    $('.plmb-contact').each(function () {
      initializeBlock($(this));
    });
  }); // Initialize dynamic block preview (editor).

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=plmb-contact', initializeBlock);
  }
})(jQuery);

(function ($) {
  const initializeBlock = function ($block) {
    // Fix block object (for preview).
    if (!$block.hasClass('plmb')) {
      $block = $block.find('.plmb');
    } // Init block


    if (!$block.hasClass('plmb-init')) {
      $block.addClass('plmb-init'); // Images number

      const nbImages = $block.find('.plmb-images-item').length; // Effect

      const effect = $block.data('effect'); // Swiper

      if (nbImages > 1) {
        // Slider
        if ($block.hasClass('slider')) {
          const plmbSwiper = new Swiper($block.find('.swiper')[0], {
            loop: true,
            autoHeight: true,
            preventClicks: false,
            preventClicksPropagation: false,
            navigation: {
              nextEl: $block.find('.swiper-button-next')[0],
              prevEl: $block.find('.swiper-button-prev')[0]
            },
            effect: effect,
            simulateTouch: typeof acf === 'undefined'
          });
        } else if ($block.hasClass('slider-dots')) {
          const plmbSwiper = new Swiper($block.find('.swiper')[0], {
            loop: true,
            autoHeight: true,
            preventClicks: false,
            preventClicksPropagation: false,
            pagination: {
              el: $block.find('.swiper-pagination')[0],
              clickable: true
            },
            effect: effect,
            simulateTouch: typeof acf === 'undefined'
          });
        } else if ($block.hasClass('slider-thumbs')) {
          const plmbSwiperThumbs = new Swiper($block.find('.swiper-thumbs')[0], {
            spaceBetween: 10,
            slidesPerView: 2,
            freeMode: true,
            preventClicks: false,
            preventClicksPropagation: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
              460: {
                slidesPerView: 4
              }
            }
          });
          const plmbSwiper = new Swiper($block.find('.swiper-top')[0], {
            loop: true,
            autoHeight: true,
            preventClicks: false,
            preventClicksPropagation: false,
            navigation: {
              nextEl: $block.find('.swiper-button-next')[0],
              prevEl: $block.find('.swiper-button-prev')[0]
            },
            thumbs: {
              swiper: plmbSwiperThumbs
            },
            effect: effect,
            simulateTouch: typeof acf === 'undefined'
          });
        }
      }
    }
  }; // Initialize each block on page load (front end).


  $(document).ready(function () {
    $('.plmb-images').each(function () {
      initializeBlock($(this));
    });
  }); // Initialize dynamic block preview (editor).

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=plmb-images', initializeBlock);
  }
})(jQuery);

(function ($) {
  const initializeBlock = function ($block) {
    // Fix block object (for preview).
    if (!$block.hasClass('plmb')) {
      $block = $block.find('.plmb');
    } // Init block


    if (!$block.hasClass('plmb-init')) {
      $block.addClass('plmb-init');

      if (!$block.has('.rounded,.rounded_large')) {
        function pictosAutoHeight($pictos) {
          let maxHeight = 0;
          gsap.set($pictos, {
            height: 'auto'
          });
          $pictos.each(function () {
            const $picto = $(this);

            if ($picto.height() > maxHeight) {
              maxHeight = $picto.height();
            }
          });
          gsap.set($pictos, {
            height: maxHeight
          });
        }

        const $pictos = $block.find('.picto-item .picto-image');
        pictosAutoHeight($pictos);
      }
    }
  }; // Initialize each block on page load (front end).


  $(document).ready(function () {
    $('.plmb-pictos').each(function () {
      initializeBlock($(this));
    });
  }); // Initialize each block on page resize (front end).

  $(window).resize(function () {
    $('.plmb-pictos').each(function () {
      initializeBlock($(this));
    });
  }); // Initialize dynamic block preview (editor).

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=plmb-pictos', initializeBlock);
  }
})(jQuery);

(function ($) {
  const initializeBlock = function ($block) {
    // Fix block object (for preview).
    if (!$block.hasClass('plmb')) {
      $block = $block.find('.plmb');
    } // Init block


    if (!$block.hasClass('plmb-init')) {
      $block.addClass('plmb-init');
      $block.on('click', '> ul li', function () {
        window.location.href = $(this).find('a').attr('href');
      });
    }
  }; // Initialize each block on page load (front end).


  $(document).ready(function () {
    $('.plmb-posts').each(function () {
      initializeBlock($(this));
    });
  }); // Initialize dynamic block preview (editor).

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=plmb-posts', initializeBlock);
  }
})(jQuery);

(function ($) {
  const initializeBlock = function ($block) {
    // Fix block object (for preview).
    if (!$block.hasClass('plmb')) {
      $block = $block.find('.plmb');
    } // Init block


    if (!$block.hasClass('plmb-init')) {
      $block.addClass('plmb-init'); // Slide

      function timelineLines() {
        const $slides = $block.find('.swiper-slide');
        const $lines = $slides.find('.line');
        let maxSlideHeight = 0;
        gsap.set($lines, {
          clearProps: 'all'
        });
        $slides.each(function () {
          const $slide = $(this); //const $image = $slide.find('.image');

          const slideHeight = $slide.height(); //const imageHeight = $image.outerHeight();

          if (slideHeight > maxSlideHeight) {
            //maxSlideHeight = slideHeight - imageHeight;
            maxSlideHeight = slideHeight;
          }
        });
        $slides.each(function () {
          const $slide = $(this);
          const $item = $slide.find('.timeline-item');
          const $line = $slide.find('.line'); //const $image = $item.find('.image');
          //gsap.to($line, { duration: 1, height: maxSlideHeight - ($item.outerHeight() - $image.outerHeight(true)) });

          gsap.to($line, {
            duration: 1,
            height: maxSlideHeight - $item.outerHeight()
          });
        });
      }

      const slidesNb = $block.find('.swiper-slide').length;

      const slides720 = function () {
        if (slidesNb > 2) {
          return 2;
        } else {
          return slidesNb;
        }
      }();

      const slides960 = function () {
        if (slidesNb > 2) {
          return 2;
        } else {
          return slidesNb;
        }
      }();

      new Swiper($block.find('.swiper')[0], {
        loop: false,
        autoHeight: false,
        preventClicks: false,
        preventClicksPropagation: false,
        navigation: {
          nextEl: $block.find('.swiper-button-next')[0],
          prevEl: $block.find('.swiper-button-prev')[0]
        },
        simulateTouch: typeof acf === 'undefined',
        slidesPerView: 1,
        on: {
          init: timelineLines,
          resize: timelineLines
        },
        breakpoints: {
          720: {
            slidesPerView: slides720
          },
          960: {
            slidesPerView: slides960
          }
        }
      }); // More

      const $moreBtns = $block.find('button.dot');
      const timelineCloseSize = $block.outerHeight();
      let timelineOpenSize, timelineOldSize;
      $moreBtns.click(function () {
        const $moreBtn = $(this);
        const tl = $moreBtn.data('tl');
        const $moreItems = $block.find('.more-item');
        const $currentMore = $moreItems.filter('[data-tl=' + tl + ']'); // If not opened

        if (!$moreBtn.hasClass('open')) {
          // Active btn
          $moreBtns.removeClass('open');
          $moreBtn.addClass('open'); // Close opened items

          gsap.set($moreItems, {
            display: 'none'
          }); // Open asked item

          gsap.set($currentMore, {
            display: 'block'
          }); // Calculate new timeline size

          timelineOldSize = $block.outerHeight();
          gsap.set($block, {
            clearProps: 'height'
          });
          timelineOpenSize = $block.outerHeight();
          gsap.set($block, {
            height: timelineOldSize
          }); // Animate

          gsap.to($block, {
            duration: 0.3,
            height: timelineOpenSize,
            onComplete: function () {
              // Scroll to asked item
              gsap.to(window, {
                duration: 1,
                scrollTo: $currentMore[0]
              });
            }
          });
          gsap.from($currentMore, {
            duration: 0.6,
            y: -60,
            autoAlpha: 0
          });
        } else {
          // Reset btn
          $moreBtn.removeClass('open'); // Close item

          gsap.to($currentMore, {
            duration: 0.6,
            y: -60,
            autoAlpha: 0,
            onComplete: function () {
              gsap.set($currentMore, {
                display: 'none',
                clearProps: 'opacity,transform,visibility'
              }); // Animate block

              gsap.to($block, {
                duration: 0.3,
                height: timelineCloseSize
              });
            }
          }); // Scroll to timeline

          gsap.to(window, {
            duration: 0.6,
            scrollTo: $block
          });
        }
      });
    }
  }; // Initialize each block on page load (front end).


  $(document).ready(function () {
    $('.plmb-timeline').each(function () {
      initializeBlock($(this));
    });
  }); // Initialize dynamic block preview (editor).

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=plmb-timeline', initializeBlock);
  }
})(jQuery);

(function ($) {
  const initializeBlock = function ($block) {
    // Fix block object (for preview).
    if (!$block.hasClass('plmb')) {
      $block = $block.find('.plmb');
    } // Init block


    if (!$block.hasClass('plmb-init')) {
      $block.addClass('plmb-init');
      $block.find('.video-cover').click(function () {
        const $overlay = $(this);
        const $video = $overlay.parent().find('.video-container iframe'); // Hide overlay

        gsap.to($overlay, {
          duration: 0.6,
          autoAlpha: 0
        }); // Play video

        const symbol = $video[0].src.indexOf("?") > -1 ? "&" : "?";
        $video[0].src += symbol + "autoplay=1";
      });
    }
  }; // Initialize each block on page load (front end).


  $(document).ready(function () {
    $('.plmb-video').each(function () {
      initializeBlock($(this));
    });
  }); // Initialize dynamic block preview (editor).

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=plmb-video', initializeBlock);
  }
})(jQuery);